/**
 * en-GB messages added by Phase 1 task K1 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const k1EnGB = {
    'kiosk.pairing.title': 'Set up this kiosk',
    'kiosk.pairing.hint': 'Enter the code from the CloudSign portal.',
    'kiosk.pairing.go': 'Pair',
    'kiosk.pairing.codeLabel': 'Pairing code',
    'kiosk.pairing.checking': 'Checking the code…',
    'kiosk.pairing.clear': 'Clear',
    'kiosk.pairing.back': 'Delete the last digit',
    'kiosk.pairing.invalid': 'That code is not valid or has expired. Ask for a new one.',
    'kiosk.pairing.noNetwork': 'Could not reach CloudSign. Check the Wi-Fi and try again.',
};
//# sourceMappingURL=k1.js.map